import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const uploadPDF = async (file, title = null, aiAssistance = null) => {
  const formData = new FormData();
  formData.append('file', file);
  
  if (title) {
    formData.append('title', title);
  }
  
  if (aiAssistance) {
    formData.append('ai_assistance', aiAssistance);
  }
  
  const response = await api.post('/api/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  
  return response.data;
};

export const getArticles = async () => {
  const response = await api.get('/api/articles');
  // Handle both formats: direct array or object with articles property
  return Array.isArray(response.data) ? response.data : response.data.articles || [];
};

export const getArticle = async (id) => {
  const response = await api.get(`/api/articles/${id}`);
  return response.data;
};

export const updateArticle = async (id, updates) => {
  const response = await api.put(`/api/articles/${id}`, updates);
  return response.data;
};

export const deleteArticle = async (id) => {
  const response = await api.delete(`/api/articles/${id}`);
  return response.data;
};

// V2 Workflow API functions
export const generateV2Summary = async (articleId) => {
  const response = await api.post(`/api/v2/generate-summary?article_id=${articleId}`);
  return response.data;
};

export const generateV2Script = async (articleId, selectedAngle, cta = null) => {
  const formData = new FormData();
  formData.append('selected_angle', selectedAngle);
  if (cta) {
    formData.append('cta', cta);
  }
  
  const response = await api.post(`/api/v2/generate-script?article_id=${articleId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const generateVideo = async (articleId, audioTrackId, avatarId = null, format = '16:9') => {
  const formData = new FormData();
  formData.append('audio_track_id', audioTrackId);
  if (avatarId) {
    formData.append('avatar_id', avatarId);
  }
  formData.append('format', format);
  
  const response = await api.post(`/api/articles/${articleId}/video/generate`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const checkVideoStatus = async (videoTrackId) => {
  const response = await api.post(`/api/video-tracks/${videoTrackId}/check-status`);
  return response.data;
};

export const generateAudio = async (articleId, scriptType, scriptText) => {
  const formData = new FormData();
  formData.append('script_type', scriptType);
  formData.append('script_text', scriptText);
  
  const response = await api.post(`/api/articles/${articleId}/audio/generate`, formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
  return response.data;
};

// V3 Script Generation API
export const generateV3Scripts = async (articleId, selectedConceptIds) => {
  const formData = new FormData();
  formData.append('selected_concept_ids', JSON.stringify(selectedConceptIds));
  
  const response = await api.post(`/api/v3/generate-scripts?article_id=${articleId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export default api;
